export function inlineYoutube() {
  const els = document.querySelectorAll('.js-inline-youtube');
  if(els.length) {
    const init = () => {
      for(let i = 0; i < els.length; i++) {
        const el = els[i];
        const videoid = el.dataset.videoid;
        new YT.Player(el, {
          videoId: videoid,
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          },
          playerVars: {
            controls: 0, // 再生ボタン等
            showinfo: 0, // 動画名等
            fs: 0, // 全画面表示ボタン
            rel: 0, // 関連動画
            disablekb: 1, // ショートカットキー
            playsinline: 1, // インライン再生
            iv_load_policy: 3,
            modestbranding: 1,
            wmode: "opaque"
          }
        });
      }
    }
    const onPlayerReady = (event)=> {
      for(let i = 0; i < els.length; i++) {
        const el = els[i];
        const videoid = el.dataset.videoid;
        const cls = el.dataset.class;
        const et = event.target;
        if(et.getVideoData()['video_id'] == videoid) {
          et.playVideo();
          et.mute();
          const timer = setInterval( () => {
            if(0 < et.getCurrentTime()) {
              clearInterval(timer);
              el.classList.add('is-started');
              if(cls) {
                el.classList.add(cls);
              } else {
                el.classList.add('loaded');
              }
            }
          }, 50);
          const visibilitychangeShow = () => {
            const visibilitySet = document.visibilityState;
            if (visibilitySet == 'visible') {
              et.playVideo();
              et.mute();
            } else {
              et.pauseVideo();
            }
          }
          document.addEventListener("visibilitychange", visibilitychangeShow);
        }
      }
    }
    const onPlayerStateChange = (event)=> {
      for(let i = 0; i < els.length; i++) {
        const el = els[i];
        const videoid = el.dataset.videoid;
        const et = event.target;
        if(et.getVideoData()['video_id'] == videoid) {
          if(event.data == YT.PlayerState.ENDED) { // 動画が停止したら
            et.seekTo(0,true); // 動画の初めにシーク
            et.playVideo(); // 動画を再生
          }
        }
      }
    }
    init();
  } 
}